import type { ClientGroupCreateRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupEventsApi } from '@/features/api/hooks/grapevine-group-events/useGrapevineGroupEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useCreateGroup = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineGroupEventsApi();

  return useApiMutation({
    mutationFn: (clientGroupCreateRequest: ClientGroupCreateRequest) =>
      api.onGroupCreateRequest({ clientGroupCreateRequest }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.GROUPS] })
  });
};
